import { safeJsonStringify } from './safe-json';

/** Is there data in body or query request? */
export function inData(req: any): any {
  return !req.body || safeJsonStringify(req.body) == '{}' ? req.query : req.body;
}

/** get user from request */
export function getUser(req: any): string {
  return req.oauth ? req.oauth.bearerToken.user_id : '';
}
